import { QTD_DEPENDENTES_ENUM } from '../helpers/funcoesPadroes';

export const IDADE_ENUM = {
    sessentaCinco: 64
};

export const validatorDependenteComValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte65AnosComAdicioanal = valoresForm => {
    const arrayDeValidacoes = [
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaior65AnosComAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarCategoriaAdicionalAcima65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', '32'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const validarLimiteCategoria = (dependentes, categoria, limit) => {
    const dependentesFiltrados = dependentes.filter(dependente => dependente['CategoriaParentesco.Categoria'] == categoria).length;

    return dependentesFiltrados < limit;
};

export const validarCategoria = (dependentes, categoria) => {
    const categoriaFiltro = categoria.trim() === 'ZTM65' ? 'ZTA64' : 'ZTM65';

    const dependenteCategoria = dependentes.filter(dependente => dependente['CategoriaParentesco.Categoria'] == categoriaFiltro).length;

    return !dependenteCategoria;
};

export const validarExisteDoisDependAcima65Anos = (dependents, idadeDigitada, idadeAssociado) => {
    const dependentesComMais65Anos = dependents.filter(dependent => dependent.Idade > IDADE_ENUM.sessentaCinco);
    const qtdDependenteMaximo65Anos = idadeAssociado > IDADE_ENUM.sessentaCinco ? QTD_DEPENDENTES_ENUM.um : QTD_DEPENDENTES_ENUM.dois;

    if (idadeDigitada > IDADE_ENUM.sessentaCinco && dependentesComMais65Anos.length >= qtdDependenteMaximo65Anos) { return true; }

    return false;
};

export const parentescosPermitidos = [
    '01',
    '02',
    '5',
    '10',
    '15',
    '32',
    '10',
    '10002',
    '10003',
    '20008',
    '20007'
];

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarParentescoPrenchido = parentesco => parentesco !== '';

const verificarCategoriaAdicionalAte65 = categoria => categoria.trim() !== 'ZTA64';
const verificarCategoriaAdicionalAcima65 = categoria => categoria.trim() !== 'ZTM65';
export const idadeAte65 = idade => idade <= IDADE_ENUM.sessentaCinco;
export const idadeAcima65 = idade => idade > IDADE_ENUM.sessentaCinco;
const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO'
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};
